import useSearchMyNetworkInfrastructure from '../infrastructure/hooks/useSearchMyNetworkInfrastructure';
import { SearchMyNetworkFormInterface } from '../domain';
import { useEffect } from 'react';

const useSearchMyNetwork = () => {
    const {
        setFormDataInfrastructure,
        submitRegistrationInfrastructure,
        clearRegistrationErrorInfrastructure,
        resetRegistrationStateInfrastructure,
        searchMyNetworkState
    } = useSearchMyNetworkInfrastructure();

    useEffect(() => {
        resetRegistrationStateInfrastructure();
    }, []);

    const setFormData = (formData: Partial<SearchMyNetworkFormInterface>) => {
        setFormDataInfrastructure(formData);
    }

    const handleSubmit = () => {
        submitRegistrationInfrastructure();
    }

    const clearRegistrationError = () => {
        clearRegistrationErrorInfrastructure();
    }

    return {
        setFormData,
        handleSubmit,
        clearRegistrationError,
        data: searchMyNetworkState
    }
}

export default useSearchMyNetwork
